// import React, { useCallback, useEffect, useState } from "react";
// import { Tables } from "../../../../components/Elements/Tables/Tables";
// import { Button } from "antd";
// import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-icon.svg";
// import { ReactComponent as EyeIcon } from "../../../../assets/svgs/eye-icon.svg";
// import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
// import { ReactComponent as BackIcon } from "../../../../assets/svgs/back-button.svg";
// import CustomSwitch from "../../../../components/Elements/CustomSwitch/CustomSwitch";
// import { useNavigate } from "react-router-dom";
// import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
// import AddNewSections from "./AddNew/AddNewSections";
// import { getApi, patchApi } from "../../../../api/api_instance";
// import { API_URLS } from "../../../../api/apiUrls";
// import dayjs from "dayjs";
// import UpdateSection from "./Update/UpdateSection";
// import toast from "react-hot-toast";
// import { Badge } from "../../../../components/Elements/TextStyles/Badge";
// import { THEME_COLORS } from "../../../../color";
// import { IoArrowBackCircleOutline } from "react-icons/io5";

// const YourQuestion = () => {
//   const [openAddNew, setOpenAddnew] = useState(false);
//   const [openUpdate, setOpenUpdate] = useState(false);
//   const navigate = useNavigate();
//   const [currentPage, setCurrentPage] = useState(1);
//   const [tableData, setTableData] = useState([]);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [sortOrder, setSortOrder] = useState("-createdAt");
//   const [sectionId, setSectionId] = useState("");
//   const [sectionName, setSectionName] = useState("");
//   const [sectionCreated, setSectionCreated] = useState(false);
//   const [sectionUpdated, setSectionUpdated] = useState(false);
//   const [loadingSwitchId, setLoadingSwitchId] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");

//   const fetchTableData = useCallback(async () => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_SECTIONS(
//           currentPage,
//           pageSize,
//           sortOrder,
//           // searchTerm
//         ),
//       });

//       if (response.success) {
//         setPageSize(response.limit);
//         setTotalRecords(response.total);
//         setTableData(
//           response.data.map((item, index) => ({
//             key: item.key,
//             serial: (currentPage - 1) * response.limit + index + 1,
//             section: item.name,
//             createdOn: dayjs(item.createdAt).format("DD/MM/YYYY"),
//             statusText: item.status,
//             status: <Badge text={item.status} />,
//             action: (
//               <div className="flex gap-4 items-center">
//                 <EyeIcon
//                   className=""
//                   style={{ fontSize: "18px", cursor: "pointer" }}
//                   onClick={() => {
//                     navigate(`/organization/my-question-bank/sub-section`, {
//                       state: { sectionId: item._id },
//                     });
//                   }}
//                 />
//                 <EditIcon
//                   style={{ fontSize: "18px", cursor: "pointer" }}
//                   onClick={() => {
//                     setOpenUpdate(true);
//                     setSectionId(item._id);
//                     setSectionName(item.name);
//                   }}
//                 />
//                 <CustomSwitch
//                   checked={item.status === "Active"}
//                   onChange={() => handleStatusChange(item._id, item.status)}
//                   disabled={loadingSwitchId === item._id} // Only disable the switch being updated
//                 />
//               </div>
//             ),
//           })),
//         );
//       }
//     } catch (error) {
//       console.error("Error in fetching table data", error);
//     }
//   }, [currentPage, pageSize, sortOrder, sectionCreated]);

//   const headers = [
//     { label: "Sr. No.", key: "serial" },
//     { label: "Section", key: "section" },
//     { label: "Created On", key: "createdOn" },
//     { label: "Status", key: "status" },
//     { label: "Action", key: "action" },
//   ];

//   const handleStatusChange = async (sectionId, currentStatus) => {
//     try {
//       setLoadingSwitchId(sectionId);
//       const updatedStatus = currentStatus === "Active" ? "Inactive" : "Active";

//       const response = await patchApi({
//         apiUrl: API_URLS.SECTION_STATUS_CHANGE(sectionId),
//         data: { status: updatedStatus },
//       });

//       if (response.success) {
//         toast.success("Status updated successfully");
//         fetchTableData();
//       }
//     } catch (error) {
//       console.error("Error in updating status", error);
//     } finally {
//       setLoadingSwitchId(null); // Reset after update
//     }
//   };

//   const handleOpenAddNew = () => {
//     setOpenAddnew(true);
//   };

//   const handleOpenViewForm = () => {
//     // navigate(`/organization/assigned-form/view/${item._id}`)
//   };

//   const handleSort = useCallback(() => {
//     setSortOrder((prevOrder) =>
//       prevOrder === "createdAt" ? "-createdAt" : "createdAt",
//     );
//   }, []);

//   const handlePageChange = useCallback((page) => {
//     setCurrentPage(page);
//   }, []);

//   useEffect(() => {
//     fetchTableData();
//   }, [fetchTableData, sectionUpdated]);

//   return (

//     <div className=" md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
//       {/* Breadcrumbs */}

//       <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2">
//         <p>Home</p>
//         <span>/</span>
//         <p>My Question Bank</p>
//         <span>/</span>
//         <TextStyles style={{ color: "#06513D" }}>Sections</TextStyles>
//       </div>

//       {/* Back + Title */}
//       <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
//         <IoArrowBackCircleOutline
//           onClick={() => navigate(-1)}
//           className="w-7 h-7 sm:w-10 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition"
//         />
//         <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] font-bold">
//           Sections
//         </div>
//       </div>

//       {/* Section Card Container */}
//       <div
//         className="rounded-xl shadow-md"
//         style={{
//           border: "1px solid #3BA2B959",
//           backgroundColor: "#fff",
//         }}
//       >
//         <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 px-4 sm:px-6 lg:px-8 pt-6">
//           {/* Left side - Total Section + Search */}
//           <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center w-full lg:w-auto">
//             {/* Total Section Badge */}
//             <div className="px-3 sm:px-4 md:px-6 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#E6EEEC] rounded-md text-[#06513D] text-sm font-light whitespace-nowrap min-w-fit">
//               TOTAL SECTION {tableData.length}
//             </div>

//             {/* Search Bar */}
//             <div className="w-full sm:w-[250px] md:w-[280px] lg:w-[300px]">
//               <SearchBar
//                 onSearch={(value) => setSearchTerm(value)}
//                 width="100%"
//                 className="w-full"
//               />
//             </div>
//           </div>

//           {/* Right side - Action Buttons */}
//           <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto lg:flex-shrink-0">
//             <Button
//               type="primary"
//               style={{ background: THEME_COLORS.green }}
//               className="text-sm font-light w-full sm:w-[140px] md:w-[150px] lg:w-40 h-[42px] flex items-center justify-center"
//               onClick={() => navigate("/organization/view")}
//             >
//               View All Question
//             </Button>
//             <Button
//               type="primary"
//               style={{ background: THEME_COLORS.green }}
//               className="text-sm font-light w-full sm:w-[120px] md:w-[130px] lg:w-40 h-[42px] flex items-center justify-center"
//               onClick={handleOpenAddNew}
//             >
//               + Add New
//             </Button>
//           </div>
//         </div>

//         {/* Divider */}
//         <div className="px-4">
//           <hr className="my-4" />
//         </div>

//         {/* Table */}
//         <div className="px-2 overflow-x-auto">
//           <Tables
//             data={tableData}
//             headers={headers}
//             pageSize={pageSize}
//             total={totalRecords}
//             current={currentPage}
//             onChange={handlePageChange}
//             onSort={handleSort}
//           />
//         </div>

//         {/* Modals */}
//         {openAddNew && (
//           <AddNewSections
//             onOpen={openAddNew}
//             onClose={() => {
//               setOpenAddnew(false);
//             }}
//             setSectionCreated={setSectionCreated}
//           />
//         )}
//         {openUpdate && (
//           <UpdateSection
//             onOpen={openUpdate}
//             onClose={() => {
//               setOpenUpdate(false);
//             }}
//             setSectionUpdated={setSectionUpdated}
//             sectionId={sectionId}
//             sectionName={sectionName}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default YourQuestion;

import React, { useCallback, useEffect, useState } from "react";
import { Tables } from "../../../../components/Elements/Tables/Tables";
import { Button } from "antd";
import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-icon.svg";
import { ReactComponent as EyeIcon } from "../../../../assets/svgs/eye-icon.svg";
import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
import CustomSwitch from "../../../../components/Elements/CustomSwitch/CustomSwitch";
import { useNavigate } from "react-router-dom";
import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
import AddNewSections from "./AddNew/AddNewSections";
import { getApi, patchApi } from "../../../../api/api_instance";
import { API_URLS } from "../../../../api/apiUrls";
import dayjs from "dayjs";
import UpdateSection from "./Update/UpdateSection";
import toast from "react-hot-toast";
import { Badge } from "../../../../components/Elements/TextStyles/Badge";
import { THEME_COLORS } from "../../../../color";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { motion, AnimatePresence } from "framer-motion";
import { CheckOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import PopupCard from "../../../Auth/PopupCard";
import { useSelector } from "react-redux";
import PermissionForm from "../../../Auth/PermissionForm";
const YourQuestion = () => {
  const [openAddNew, setOpenAddnew] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [tableData, setTableData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sortOrder, setSortOrder] = useState("-createdAt");
  const [sectionId, setSectionId] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [sectionCreated, setSectionCreated] = useState(false);
  const [sectionUpdated, setSectionUpdated] = useState(false);
  const [loadingSwitchId, setLoadingSwitchId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });

  const [showPermission, setPermission] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const isPermissionCompleted = user?.isCompleted;
  // console.log(user, "useruseruseruser in your question");
  // console.log(isPermissionCompleted, "PermissionFormPermissionForm");

  // Automatically show permission form when component mounts if not completed
  useEffect(() => {
    if (!isPermissionCompleted) {
      setPermission(true);
    }
  }, [isPermissionCompleted]);

  // Detect mobile screen size (you can tweak 768px breakpoint)
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize(); // initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // useEffect(() => {
  //   fetchSections(); // API call to refresh section list
  // }, [sectionCreated]);
  const triggerPopup = (type, title, message, duration = 2000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(
      () => setShowPopup(false),

      duration,
    );
  };

  const fetchTableData = useCallback(
    async (search = "") => {
      try {
        const response = await getApi({
          apiUrl: API_URLS.GET_SECTIONS(
            currentPage,
            pageSize,
            sortOrder,
            search,
          ),
        });

        if (response.success) {
          setPageSize(response.limit);
          setTotalRecords(response.total);
          setTableData(
            response.data.map((item, index) => ({
              key: item.key,
              serial: (
                <div className="text-center" title="">
                  {(currentPage - 1) * response.limit + index + 1}
                </div>
              ),
              _id: item._id,
              section: (
                <div className="text-center" title="">
                  {item.name}
                </div>
              ),
              createdOn: (
                <div className="text-center" title="">
                  {dayjs(item.createdAt).format("DD/MM/YYYY")}
                </div>
              ),
              statusText: item.status,
              status: (
                <div className="flex justify-center" title="">
                  <Badge text={item.status} />
                </div>
              ),
              action: (
                <div
                  className="flex gap-1 sm:gap-2 items-center justify-center"
                  title=""
                >
                  <EyeIcon
                    style={{ fontSize: "18px", cursor: "pointer" }}
                    onClick={() => {
                      navigate(`/organization/my-question-bank/sub-section`, {
                        state: { sectionId: item._id },
                      });
                    }}
                  />
                  <EditIcon
                    style={{ fontSize: "18px", cursor: "pointer" }}
                    onClick={() => {
                      setOpenUpdate(true);
                      setSectionId(item._id);
                      setSectionName(item.name);
                      console.log(item.name, "item.name");
                    }}
                  />
                  <CustomSwitch
                    checked={item.status === "Active"}
                    onChange={() => handleStatusChange(item._id, item.status)}
                    disabled={loadingSwitchId === item._id} // Only disable the switch being updated
                  />
                </div>
              ),
              rawStatus: item.status,
            })),
          );
        }
      } catch (error) {
        console.error("Error in fetching table data", error);
      }
    },
    [currentPage, pageSize, sortOrder, sectionCreated],
  );
  useEffect(() => {
    fetchTableData(searchTerm); // API call to refresh section list
  }, [sectionCreated]);
  const headers = [
    { label: "Sr. No.", key: "serial" },
    { label: "Section", key: "section" },
    { label: "Created On", key: "createdOn" },
    { label: "Status", key: "status" },
    { label: "Action", key: "action" },
  ];

  const handleStatusChange = async (sectionId, currentStatus) => {
    try {
      setLoadingSwitchId(sectionId);
      const updatedStatus = currentStatus === "Active" ? "Inactive" : "Active";

      const response = await patchApi({
        apiUrl: API_URLS.SECTION_STATUS_CHANGE(sectionId),
        data: { status: updatedStatus },
      });

      if (response.success) {
        // Modal.success({
        //   icon: null,
        //   centered: true,
        //   closable: true,
        //   className: "custom-success-modal",
        //   okButtonProps: { style: { display: "none" } },
        //   content: (
        //     <div className="flex flex-col items-center text-center p-4">
        //       <div className="bg-slate-300 p-2 rounded-full">
        //         <CheckOutlined style={{ fontSize: "48px", color: "#06513D" }} />
        //       </div>

        //       <p className="text-[15px] mt-2 mb-1 font-medium">Success!</p>
        //       <h2 className="text-xl font-semibold text-[#000000]">
        //         Status updated successfully
        //       </h2>
        //     </div>
        //   ),
        // });

        triggerPopup("success", "Success", "Status updated successfully");

        setTimeout(() => {
          Modal.destroyAll(); // Close all modals
          // handleSuccessComplete();
          // onClose();
        }, 2000);
        fetchTableData(searchTerm);
      }
    } catch (error) {
      console.error("Error in updating status", error);
    } finally {
      setLoadingSwitchId(null);
    }
  };

  const handleOpenAddNew = () => {
    setOpenAddnew(true);
  };
  const handleSearch = (value) => {
    console.log(`Search input changed: "${value}"`);
    setSearchTerm(value);
    setCurrentPage(1);
    // The useEffect with debounce will handle the API call
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchTableData(searchTerm); // call API after typing stops
    }, 500); // 500ms debounce

    return () => clearTimeout(delayDebounce); // cleanup on new typing
  }, [searchTerm, fetchTableData]);

  const handleSort = useCallback(() => {
    setSortOrder((prevOrder) =>
      prevOrder === "createdAt" ? "-createdAt" : "createdAt",
    );
  }, []);

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  useEffect(() => {
    fetchTableData();
  }, [fetchTableData, sectionUpdated]);

  // Animation variants for framer-motion
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
      {!isPermissionCompleted && showPermission && (
        <PermissionForm
          permissionConClose={() => setPermission(false)}
          //  permissionConClose={handlePermissionClose}
          // isClosable={isPermissionCompleted} // Pass prop to control close button visibility
        />
      )}
      {/* Breadcrumbs */}
      <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2">
        <p>Home</p>
        <span>/</span>
        <p>My Question Bank</p>
        <span>/</span>
        <TextStyles style={{ color: "#06513D" }}>Sections</TextStyles>
      </div>

      {/* Back + Title */}
      <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
        {/* <IoArrowBackCircleOutline
          onClick={() => navigate(-1)}
          className="w-7 h-7 sm:w-10 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition cursor-pointer"
        /> */}
        <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] font-bold">
          Sections
        </div>
      </div>

      {/* Section Card Container */}
      <div
        className="rounded-xl shadow-md"
        style={{
          border: "1px solid #3BA2B959",
          backgroundColor: "#fff",
        }}
      >
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 px-4 sm:px-6 lg:px-8 pt-6">
          {/* Left side - Total Section + Search */}
          <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center w-full lg:w-auto">
            {/* Total Section Badge */}
            <div className="px-3 sm:px-4 md:px-6 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#E6EEEC] rounded-md text-[#06513D] text-sm font-light whitespace-nowrap min-w-fit">
              TOTAL SECTION {tableData.length}
            </div>

            {/* Search Bar */}
            <div className="w-full sm:w-[250px] md:w-[280px] lg:w-[300px]">
              <SearchBar
                onSearch={handleSearch}
                width="100%"
                className="w-full"
              />
            </div>
          </div>

          {/* Right side - Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto lg:flex-shrink-0">
            <Button
              type="primary"
              style={{ background: THEME_COLORS.green }}
              className="text-sm font-light w-full sm:w-[140px] md:w-[150px] lg:w-40 h-[42px] flex items-center justify-center"
              onClick={() => navigate("/organization/view")}
            >
              View All Question
            </Button>
            <Button
              type="primary"
              style={{ background: THEME_COLORS.green }}
              className="text-sm font-light w-full sm:w-[120px] md:w-[130px] lg:w-40 h-[42px] flex items-center justify-center"
              onClick={handleOpenAddNew}
            >
              + Add New
            </Button>
          </div>
        </div>

        {/* Divider */}
        <div className="px-4">
          <hr className="my-4" />
        </div>

        {/* Content: Table for desktop, Cards for mobile */}
        <div className="px-2 overflow-x-auto">
          {!isMobile ? (
            <Tables
              data={tableData.map((item) => ({
                ...item,
              }))}
              headers={headers}
              pageSize={pageSize}
              total={totalRecords}
              current={currentPage}
              onChange={handlePageChange}
              onSort={handleSort}
            />
          ) : (
            <div className="space-y-4">
              <AnimatePresence>
                {tableData.map((item) => (
                  <motion.div
                    key={item._id}
                    initial="hidden"
                    animate="visible"
                    exit="hidden"
                    variants={cardVariants}
                    transition={{ duration: 0.3 }}
                    className="bg-white rounded-lg shadow-md p-4 border border-gray-300"
                  >
                    {/* Section Name */}
                    <div className="flex justify-between mb-2">
                      <span className="font-semibold text-[#06513D]">
                        Section Name
                      </span>
                      <span className="font-semibold text-[#06513D]">
                        {item.section}
                      </span>
                    </div>

                    {/* Created On */}
                    <div className="flex justify-between mb-2 text-sm text-gray-500">
                      <span>Created</span>
                      <span>{item.createdOn}</span>
                    </div>

                    {/* Status */}
                    <div className="flex justify-between mb-2 items-center">
                      <span>Status</span>
                      <Badge text={item.statusText} />
                    </div>

                    {/* Actions */}
                    <div className="flex justify-between items-center mt-4">
                      <div className="flex gap-4">
                        <EyeIcon
                          className="cursor-pointer"
                          onClick={() => {
                            navigate(
                              `/organization/my-question-bank/sub-section`,
                              {
                                state: { sectionId: item._id },
                              },
                            );
                          }}
                        />
                        <EditIcon
                          className="cursor-pointer"
                          onClick={() => {
                            setOpenUpdate(true);
                            setSectionId(item._id);
                            setSectionName(item.section);
                          }}
                        />
                      </div>
                      <CustomSwitch
                        checked={item.rawStatus === "Active"}
                        onChange={() =>
                          handleStatusChange(item._id, item.rawStatus)
                        }
                        disabled={loadingSwitchId === item._id}
                      />
                    </div>
                  </motion.div>
                ))}
              </AnimatePresence>
            </div>
          )}
        </div>

        {/* Modals */}
        {openAddNew && (
          <AddNewSections
            onOpen={openAddNew}
            onClose={() => {
              setOpenAddnew(false);
            }}
            setSectionCreated={setSectionCreated}
          />
        )}
        {openUpdate && (
          <UpdateSection
            onOpen={openUpdate}
            onClose={() => {
              setOpenUpdate(false);
            }}
            setSectionUpdated={setSectionUpdated}
            sectionId={sectionId}
            sectionName={sectionName}
          />
        )}

        {showPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <PopupCard
              type={popupData.type}
              title={popupData.title}
              message={popupData.message}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default YourQuestion;
